var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3002 0.710703C12.9102 0.320703 12.2802 0.320703 11.8902 0.710703L7.00022 5.5907L2.11022 0.700703C1.72022 0.310703 1.09021 0.310703 0.700215 0.700703C0.310215 1.0907 0.310215 1.7207 0.700215 2.1107L5.59022 7.0007L0.700215 11.8907C0.310215 12.2807 0.310215 12.9107 0.700215 13.3007C1.09021 13.6907 1.72022 13.6907 2.11022 13.3007L7.00022 8.4107L11.8902 13.3007C12.2802 13.6907 12.9102 13.6907 13.3002 13.3007C13.6902 12.9107 13.6902 12.2807 13.3002 11.8907L8.41021 7.0007L13.3002 2.1107C13.6802 1.7307 13.6802 1.0907 13.3002 0.710703Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelMobile);
export default __webpack_public_path__ + "static/media/cancel-mobile.9861aaa8.svg";
export { ForwardRef as ReactComponent };